import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';
import {Subject, of} from 'rxjs';
import {Observable} from 'rxjs';
import {KeyLabelEntry} from '@visana-web/basic-ui';


@Injectable()
export class KeyDateService {


  constructor(private translateService: TranslateService) {
  }


  getKeyDates(): Observable<KeyLabelEntry[]> {
    return new KeyDatesObserver(this.translateService);
  }
}

export class KeyDatesObserver<T> extends Subject<T> {


  private static dateFormat: string = 'YYYY-MM-DD HH:mm:ss.SSSZZ';

  constructor(private translateService: TranslateService) {
    super();
  }

  /**
   * Abhängig vom heutigen Tag ändern sich die Variabeln "calNext1" und "calNext2".
   *
   * Wenn heutiges Datum kleiner Juli, dann "calNext1" = "yy, july, 1" und "calNext2" = "yy + 1 , january, 1"
   *
   * Wenn heutiges Datum grösser Juli, dann "calNext1" = "yy + 1, january, 1" und "calNext2" = "yy + 1 , july, 1"
   *
   * @returns {any[]}
   */
  private getDatesRaw(): moment.Moment[] {

    const calToday = moment()
    const calNext1 = moment()
    const calNext2 = moment()

    const january = moment().month('January').month()
    const july = moment().month('July').month()
    const november = moment().month('November').month()
    const currentMonth = moment().month()
    calToday.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0})
    calNext1.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0})
    calNext2.set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0})
    if (currentMonth < july) {
      calNext1.set({'year': calToday.get('year'), 'month': july, 'date': 1})
      calNext2.set({'year': calToday.get('year') + 1, 'month': january, 'date': 1})
      const datesRaw: any[] = [calToday, calNext1, calNext2]
      return datesRaw
    } else if (currentMonth > november) {
      calNext1.set({'year': calToday.get('year') + 1, 'month': january, 'date': 1})
      calNext2.set({'year': calToday.get('year') + 1, 'month': july, 'date': 1})
        const datesRaw: any[] = [calToday, calNext1, calNext2]
        return datesRaw
    } else {
      calNext1.set({'year': calToday.get('year') + 1, 'month': january, 'date': 1})
      const datesRaw: any[] = [calToday, calNext1]
      return datesRaw;
    }
  }





  subscribe(generatorOrNext?: any, error?: any, complete?: any): any {
    return of<KeyLabelEntry[]>(this.getDatesRaw().map(entry => {
      entry.locale(this.translateService.currentLang);
      return {
        key: entry.format(KeyDatesObserver.dateFormat),
        labelValue: entry.format('LL'),
        needsReloadAfterLanguageChange: true
      };
    })).subscribe(generatorOrNext);
  }


  unsubscribe(): void {
  }

}


